<template>
  <div class="add-fee-leave-type">
    <v-form @submit.prevent="" v-model="submitForm">
      <v-row>
        <v-col cols="8">
          <h1 class="text-left ml-8 my-2">
            <span v-if="!is_editing">Add</span>
            <span v-else>Edit</span> Leave Type
          </h1>
          <p class="text-left ml-8 mb-0">Allocate allowances to Leave Types</p>
          <p class="mt-0 pt-0 ml-8 text-left red--text"></p>

        </v-col>
        <v-col cols="4" class="text-right" v-if="currentUser.privileges.canManageStaffLeaveTypes">

              <v-btn
                v-if="is_editing"
                color="red"
                class="my-2 mr-8"
                @click="showDeleteDialog"
                rounded
                outlined
              >
                Delete
              </v-btn>
        </v-col>
      </v-row>

      <v-row class="mx-4">
        <v-col class="cols-12 pt-0">
          <v-card class="mb-7">
            <v-container>
              <!-- row for leave data fields -->
              <v-row>
                <v-col cols="12" md="6">
                  <p class="text-left mx-2 mb-1">Title</p>
                  <v-text-field
                    v-model="leave_type.title"
                    :error="formErrors.titleError != null"
                    :error-messages="formErrors.titleError"
                    outlined
                    :rules="[rules.required, rules.category_name]"
                    dense
                    @input="formErrors.titleError = null"
                    placeholder="eg. Casual Leave"
                    class="rounded-input"
                    hide-details="auto"
                    maxlength="55"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <p class="text-left mx-2 mb-1">Code</p>
                  <v-text-field
                    v-model="leave_type.code"
                    :error="formErrors.codeError != null"
                    :error-messages="formErrors.codeError"
                    outlined
                    counter="4"
                    :rules="[rules.required, rules.code]"
                    dense
                    @input="formErrors.codeError = null"
                    placeholder="eg. CL"
                    class="rounded-input"
                    maxlength="4"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- row for paid status switch -->
              <v-row justify="center">
                <v-col cols="6" md="2" sm="4" align-self="center">
                  <p class="font-weight-medium">Paid Status:</p>
                </v-col>
                <v-col cols="6" md="2" sm="4" align-self="center">
                  <v-switch
                    v-model="leave_type.is_paid"
                    :label="leave_type.is_paid ? 'Paid' : 'Unpaid'"
                    class="my-7 mx-5"
                  >
                  </v-switch>
                </v-col>
              </v-row>

              <!-- row for data table -->
              <v-row class="my-2" justify="center">
                <v-col cols="12" md="8" sm="10">
                  <v-card>
                    <v-data-table
                      class="ma-2 pa-2 mb-2"
                      :headers="headers"
                      :items="allowances"
                      
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.validity="{ item }">
                        <v-menu
                            v-model="menu[allowances.indexOf(item)]"
                            :close-on-content-click="false"
                            max-width="290"
                        >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="formattedDateRange(item.validity)"
                                readonly
                                :rules="[rules.required]"
                                clearable
                                @click:clear="item.validity=[]"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                            no-title
                              range
                              v-model="item.validity"
                              :min="item.validity[0]"
                              @change="onValidityDateSelected(item)"
                            >
                            <p v-if="item.validity.length == 1">Start Date selected. Please, select an End Date.</p>
                            </v-date-picker>
                          </v-menu>
                        <!-- {{ item.allowed_days ? null : '-' }} -->
                      </template>
                      <template v-slot:item.allowed_days="{ item }">
                        <v-text-field
                          v-model.number="item.allowed_days"
                          :rules="[rules.requiredNum, rules.numbersOnly]"
                          clearable
                          single-line
                          center
                          class="centered-input"
                        >
                          {{ item.allowed_days }}
                        </v-text-field>
                        <!-- {{ item.allowed_days ? null : '-' }} -->
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>

              <div class="text-right mx-4 my-4">
                <v-btn
                  v-if="currentUser.privileges.canManageStaffLeaveTypes"
                  class="mr-4"
                  color="red"
                  :to="{ name: 'StaffLeaveTypes' }"
                  rounded
                  outlined
                >
                  Cancel
                </v-btn>
                <!-- Removed disabled from submit button :disabled="isLoading || !submitForm" -->
                <v-btn
                  v-if="currentUser.privileges.canManageStaffLeaveTypes"
                  color="primary"
                  type="submit"
                  :disabled="!submitForm"
                  @click="saveLeaveType"
                  rounded
                  >Submit</v-btn
                >
              </div>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <!-- delete dialog component -->
    <DeleteConfirmationDialog
      title="Are you sure you want to delete this Leave Category?"
      description="This action cannot be reversed!"
      :visible="showDeleteConfirmation"
      @deleteObject="deleteObjectConfirmation"
    />

    <!-- snackbar -->
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog";
import moment from "moment";


export default {
  name: "AddEditLeaveType",
  components: {
    DeleteConfirmationDialog,
  },
  data() {
    return {
      moment: moment,
      menu: [],
      is_editing: false,
      submitForm: false,
      showDeleteConfirmation: false,
      rules: {
        required: (v) => !!v || "This field is required",
        requiredNum: (v) => !!v || v==0 || "This field is required",
        category_name: (v) => /^[a-zA-Z0-9_ ]{1,55}$/.test(v) || "Invalid",
        code: (v) => /^[a-zA-Z0-9]{1,4}$/.test(v) || "Invalid",
        allowances: (v) => /^[0-9]+$/.test(v) || "Invalid",
        numbersOnly: (v) => !v || !/[^0-9]/.test(v) || "Invalid",
      },

      leave_type: {
        title: null,
        code: null,
        is_paid: true,
      },

      headers: [
        {
          text: "Category",
          align: "start",
          value: "category.title",
          sortable: true,
          width: "30%",
        },
        {
          text: "Allowed Days",
          align: "center",
          value: "allowed_days",
          sortable: true,
          width: "20%",
        },
        {
          text: "Validity",
          align: "center",
          value: "validity",
          sortable: false
        },
      ],

      allowances: [],

      // allowances: {
      // 	category_id: null,
      // 	allowed_days: null,
      // },

      formErrors: {
        titleError: null,
        codeError: null,
      },

      // this.leave_type.is_paid: false,

      snackbar: {
        visible: false,
        message: "",
        color: "dark",
      },
    };
  },
  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },

  methods: {
    ...mapActions(["setLoading"]),

    formattedDateRange(validity) {
      if (!validity || validity.length == 0) return;
      if(validity.length == 1){
        return moment(validity[0]).format("ll") +
        " - ";
      }
      return moment(validity[0]).format("ll") +
        " - " +
        moment(validity[1]).format("ll");
    },

    async getLeaveTypeDetails(){
      var url = endpoints.staffLeaveTypes + `?id=${this.$route.params.id}`;
      var response = await api.call(this.essentials, url);
      console.log(response);
      this.leave_type = response;
      this.allowances = response.allowances;
    },

    async getAllStaffCategoryAllowances() {
      this.allowances = await api.call(
        this.essentials,
        endpoints.getStaffCategoryAllowances
      );

    },

    async saveLeaveType() {
      if(!this.validateFields()) return;
      var allowancesBody = this.allowances.map(a => {
        a.start_date = a.validity[0];
        a.end_date = a.validity[1];
        return a;
      })
      var body = {
        leave_type: this.leave_type,
        allowances: allowancesBody,
        is_editing: this.$route.params.id != null,
      };

      var response = await api.call(
        this.essentials,
        endpoints.staffLeaveTypes,
        api.Methods.POST,
        body
      );
      if(response) this.$router.push({ name: 'StaffLeaveTypes' });
    },

    validateFields() {
      Object.keys(this.formErrors).forEach((v) => (this.formErrors[v] = null));
      if (!this.leave_type.title) {
        this.formErrors.titleError = "This field is required";
        return false;
      }

      if (!this.leave_type.code) {
        this.formErrors.codeError = "This field is required";
        return false;
      }

      // check if any allowance value is not set
      for (let i = 0; i < this.allowances.length; i++) {
        if (this.allowances[i].allowed_days===null) {
          this.snackbar.message = "Allowance fields cannot be empty";
          this.snackbar.color = "error";
          this.snackbar.visible = true;
          return false;
        } else if (!/^-?\d+$/.test(this.allowances[i].allowed_days)) {
          this.snackbar.message =
            "Invalid allowance type. Please use a number only.";
          this.snackbar.color = "error";
          this.snackbar.visible = true;
          return false;
        }
      }



      return true;
    },

    async onValidityDateSelected(allowance) {
      console.log(allowance.validity);
      if(allowance.validity.length == 2) {
        this.menu[this.allowances.indexOf(allowance)] = false;
        if(moment(allowance.validity[0]).isAfter(moment(allowance.validity[1]))) {
          this.snackbar.message = "Start date in validity should be before end date";
          this.snackbar.visible = true;
          this.snackbar.color = "red";
          this.submitForm = false;
          return;
        }
        if(!(moment(allowance.validity[0]).isBefore(moment()) && moment(allowance.validity[1]).isAfter(moment()))) {
          this.snackbar.message = "Start date should be before today and end date should be after today.";
          this.snackbar.visible = true;
          this.snackbar.color = "red";
          allowance.validity = [];
          this.submitForm = false;
          return;
        }

      }
    },

    async showDeleteDialog() {
      if(this.leave_type.used) {
        this.snackbar.message = "Leave Type cannot be deleted since its already used in one or more Staff Leaves";
        this.snackbar.color = "red";
        this.snackbar.visible = true;
        return;
      }
      this.showDeleteConfirmation = true;
    },

    async deleteObjectConfirmation(confirm) {
      this.showDeleteConfirmation = false;
      if (confirm) {
        var response = api.call(this.essentials, endpoints.staffLeaveTypes + `${this.leave_type.id}/`, api.Methods.DELETE);
        if (response) this.$router.push({ name: 'StaffLeaveTypes' });
      }
    },

    async handleApiErrors(err) {
      this.setLoading(false);
      console.log(err);
      if (err.response) {
        if (err.response.status == 406) {
          this.formErrors.codeError = "Code is already used";
          this.snackbar.message =
            "Leave Type Code is already used. Please use a different code";
          this.snackbar.color = "error";
          this.snackbar.visible = true;
        }
      } else {
        this.snackbar.message = "Unable to process request";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
    },
  },

  async created() {
    if (this.$route.params.id) {
      this.is_editing = true;
      // await this.getCategoryDetails();
      this.getLeaveTypeDetails();
    } else {
      this.getAllStaffCategoryAllowances();
    }
  },
};
</script>

<style scoped>
.text-white {
  color: white !important;
}
.rounded-input {
  border-radius: 12px !important;
}

.centered-input >>> input {
  text-align: center;
}
</style>
